import { withDefaults } from "@kalkulacka-one/next/config";

export const appConfig = withDefaults({
  domainPath: "www.volebnakalkulacka.sk",

  i18n: {
    defaultLocale: "sk",
    locales: ["sk"],
  },

  links: {
    privacy: "/soukromi",
  },
});
